module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av305-bf553d057e9aafe3921e7511735db64c.jpg";